<template>
  <div>
    <v-card outlined elevation="1" class="px-2 holidays-section">
      <v-card-title
        class="
          d-flex
          justify-space-between
          flex-wrap
          secondary--font
          font-weight-medium-custom
        "
      >
        <p class="mt-1">Holidays</p>
        <div class="d-flex flex-wrap">
          <v-btn
            :disabled="readOnly"
            class="font-weight-bold px-2"
            text
            @click="toggleAddHoliday()"
          >
            <v-icon> mdi-plus </v-icon>
            <span class="pl-2 pr-3"> Add Holidays </span>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text class="body-1">
        Holidays will be skipped when calculating SLA for tickets.
      </v-card-text>
      <v-data-table
        :headers="headers"
        :items="holidayList"
        :items-per-page="10"
        :hide-default-footer="holidayList.length > 9 ? false : true"
        class="elevation-0 holiday-table"
        :class="readOnly ? 'hide-actions' : ''"
      >
        <template v-slot:[`no-data`]>
          <div class="body-1 my-12 text-center">
            <div>
              <v-icon size="35px"> mdi-calendar-month </v-icon>
            </div>
            <p class="mt-5 mb-12">
              No holidays have been added to <br />
              this Service Hours set.
            </p>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="action">
            <v-icon small class="mr-2" @click="editHolidayToggle(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteHoliday(item)"> mdi-delete </v-icon>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <!-- Add new holidays -->
    <v-dialog v-model="addEditHolidayDialog" max-width="500">
      <v-card class="pa-2 py-3">
        <v-card-title class="text-h6 font-weight-medium-custom">
          <span class="secondary--font text-capitalize">
            {{ holidayAction }} Holiday{{ holidayAction == "add" ? "s" : "" }}
          </span>
        </v-card-title>

        <v-card-text class="body-2">
          <p class="body-1">Provide the following details</p>

          <v-form class="mt-8" ref="holidayForm" v-model="formValid">
            <v-text-field
              v-model="name"
              label="Name"
              class="required"
              outlined
              required
              :rules="[(v) => !!v || 'Name is required']"
            >
            </v-text-field>

            <v-menu
              ref="menu"
              v-model="datePickermenu"
              transition="scale-transition"
              min-width="250px"
              class="date-picker-custom"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="selectedDate"
                  outlined
                  readonly
                  label="Date"
                  v-bind="attrs"
                  v-on="on"
                  class="required"
                  id="date-range-picker"
                  append-icon="event"
                  @click:append="datePickermenu = true"
                  clearable
                  required
                  :rules="[(v) => !!v || 'Date is required']"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                color="#03B6FC"
                :popover="{ visibility: 'click' }"
                :input-props="{ placeholder: 'Select Date' }"
                scrollable
                z-index="999"
                :min="minDate"
                :max="maxDate"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  class="font-weight-bold"
                  id="confirm-date-filter"
                  @click="datePickermenu = false"
                  >Ok</v-btn
                >
              </v-date-picker>
            </v-menu>
            <v-alert type="error" v-if="existHoliday" dense text class="mb-0">
              Date already exists.
            </v-alert>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="hideHolidayModal()" class="font-weight-bold">
            Cancel
          </v-btn>
          <v-btn
            v-if="holidayAction == 'add'"
            :dark="formValid"
            @click="addHoliday()"
            :disabled="!formValid"
            class="font-weight-bold"
          >
            add
          </v-btn>
          <v-btn v-else dark @click="editHoliday()" class="font-weight-bold">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    holidays: [Array, Object],
    readOnly: Boolean,
  },
  data() {
    return {
      existHoliday: false,
      addEditHolidayDialog: false,
      datePickermenu: false,
      holidayAction: "add",
      minDate: `${new Date().getFullYear()}-01-01`,
      maxDate: `${new Date().getFullYear()}-12-31`,
      headers: [
        {
          text: "Date",
          align: "start",
          value: "date",
          sortable: false,
        },
        { text: "Name", value: "name", sortable: false },
        { text: "", value: "actions", sortable: false, align: "right" },
      ],
      holidayList: this.holidays,
      name: null,
      date: null,
      formValid: false,
      selectedData: null,
    };
  },

  computed: {
    selectedDate: {
      get() {
        let holidayDate = this.date;
        if (this.date) {
          holidayDate = this.$options.filters.formatDate(holidayDate, "MMM DD");
        }
        return holidayDate;
      },
      set(newName) {
        return newName;
      },
    },
  },

  mounted() {
    this.sortedHolidays();
  },

  methods: {
    /** method to sort the list of holidays */
    sortedHolidays() {
      this.holidayList.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date);
      });
      return this.holidayList;
    },

    /** method to open dialog for add the holiday */
    toggleAddHoliday() {
      this.holidayAction = "add";
      this.addEditHolidayDialog = true;
    },

    hideHolidayModal() {
      this.addEditHolidayDialog = false;
      if (this.name || this.date) {
        this.name = null;
        this.date = null;
        this.$refs.holidayForm.reset();
      }
      this.$refs.holidayForm.resetValidation();
    },
    editHolidayToggle(data) {
      let itemDate = `${data.date} ${new Date().getFullYear()}`;
      itemDate = this.$options.filters.formatDate(itemDate, "YYYY-MM-DD");
      this.selectedData = data;
      this.holidayAction = "edit";
      this.name = data.name;
      this.date = itemDate;
      this.addEditHolidayDialog = true;
    },

    /** method to add holiday */
    addHoliday() {
      if (this.formValid) {
        let date = this.$options.filters.formatDate(this.date, "MMM DD");
        let holiday = {
          name: this.name,
          date: date,
          id: this.name + date,
        };
        if (this.holidayList.length) {
          this.holidayList.forEach((item) => {
            if (item.date == date) {
              this.existHoliday = true;
              setTimeout(() => {
                this.existHoliday = false;
              }, "5000");
            }
          });
          if (!this.existHoliday) {
            this.addDataToTable(holiday);
          }
        } else {
          this.addDataToTable(holiday);
        }
      }
    },

    addDataToTable(holiday) {
      this.holidayList.push(holiday);
      this.sortedHolidays();
      this.$emit("update", this.holidayList);
      this.addEditHolidayDialog = false;
      this.$refs.holidayForm.reset();
    },

    /** method to edit holiday */
    editHoliday() {
      let holiday = {
        name: this.name,
        date: this.$options.filters.formatDate(this.date, "MMM DD"),
      };
      if (this.selectedData) {
        this.holidayList = this.holidayList.map((item) => {
          if (item.id == this.selectedData.id) {
            return { ...item, ...holiday };
          }
          return item;
        });
        this.$emit("update", this.holidayList);
      }
      this.addEditHolidayDialog = false;
    },

    /** method to delete holiday */
    deleteHoliday(data) {
      this.selectedData = data;
      if (this.selectedData) {
        this.holidayList.forEach((item, index) => {
          if (item.id == this.selectedData.id) {
            this.holidayList.splice(index, 1);
          }
        });
        this.$emit("update", this.holidayList);
      }
    },
  },
};
</script>

<style lang="scss">
.action {
  visibility: hidden;
}
.holiday-table tr:hover {
  .action {
    visibility: visible;
  }
}
.hide-actions .action {
  visibility: hidden !important;
}
</style>
